// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"90e51efa","38":"ae4d365e","234":"f82d7d9f","443":"9a276036","749":"51328a63","861":"10bf41b6","952":"71690570","997":"88997335"}[chunkId] + ".chunk.js";
};